import jQuery from 'jquery';
import './style.scss';

import LazyLoad from './lazyLoad/lazyLoad';
import Subpage from '../src/Layout/Subpage';

// Components

import Cookie from '../src/Components/Cookie/Cookie';
import Form from '../src/Components/Form/Form';

// Sections
import SliderFullScreen from '../src/Sections/SliderFullScreen/SliderFullScreen';
import ColumnsBox1 from '../src/Sections/ColumnsBox1/ColumnsBox1';
import ColumnsBox2 from '../src/Sections/ColumnsBox2/ColumnsBox2';
import ChargeBenefits from '../src/Sections/ChargeBenefits/ChargeBenefits';
import ListFAQ from '../src/Sections/ListFAQ/ListFAQ';
import GridWithSteps from '../src/Sections/GridWithSteps/GridWithSteps';
import BecomePartnerForm from '../src/Sections/BecomePartnerForm/BecomePartnerForm';
import SectionWithSteps from '../src/Sections/SectionWithSteps/SectionWithSteps';
import NewsLetter from '../src/Sections/NewsLetter/NewsLetter';
import ElasticGrid from '../src/Sections/ElasticGrid/ElasticGrid';
import ContactForm3 from '../src/Sections/ContactForm3/ContactForm3';
import PriceList from '../src/Sections/PriceList/PriceList';

// pages
import Stations from '../src/Pages/Stations/Stations';
import Homepage from '../src/Pages/Homepage/Homepage';


LazyLoad.init();

document.addEventListener("DOMContentLoaded", function() {
    
    Subpage.init();

    // components
    Cookie.init();
    Form.init();

    //sections
    SliderFullScreen.init();
    ColumnsBox1.init();
    ColumnsBox2.init();
    ChargeBenefits.init();
    ListFAQ.init();
    GridWithSteps.init();
    BecomePartnerForm.init();
    SectionWithSteps.init();
    NewsLetter.init();
    ElasticGrid.init();
    ContactForm3.init();
    PriceList.init();
    
    //pages
    Stations.init();
    Homepage.init();
    
});
